// src/sections/About.js
import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig/firebase";
import { personalInfo, sectionTexts } from "../data";

const About = () => {
  const [aboutData, setAboutData] = useState({
    title: sectionTexts.about.title,
    subtitle: sectionTexts.about.subtitle,
    profileImage:
      "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/perfil%2Fgabylan22.jpg?alt=media&token=0653be0b-43d0-4eb5-b5d2-5826561cce9a",
  });
  const [loading, setLoading] = useState(true);

  // Cargar datos desde Firestore
  useEffect(() => {
    const loadAboutData = async () => {
      try {
        const docRef = doc(db, "content", "about");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setAboutData(docSnap.data());
        }
      } catch (error) {
        console.error("Error al cargar datos de About:", error);
      } finally {
        setLoading(false);
      }
    };

    loadAboutData();
  }, []);

  if (loading) {
    return (
      <section
        id="about"
        className="h-screen flex items-center justify-center bg-black"
      >
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
      </section>
    );
  }

  return (
    <section id="about" className="h-screen flex items-center justify-center bg-black px-8 sm:px-12 lg:px-16">
      <div className="max-w-6xl w-full">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Profile Image - Centrada */}
          <div className="flex items-center justify-center lg:justify-end">
            <div className="relative">
              <img
                src={aboutData.profileImage}
                alt={`${personalInfo.name} - Profile`}
                className="w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 rounded-full object-cover grayscale hover:grayscale-0 transition-all duration-700 shadow-2xl"
              />
            </div>
          </div>

          {/* About Content - Centrado */}
          <div className="flex items-center justify-center lg:justify-start">
            <div className="max-w-md text-center lg:text-left">
              {/* Title */}
              <h2 className="text-3xl sm:text-4xl font-light text-white mb-8 tracking-wide">
                {aboutData.title}
              </h2>

              {/* Bio - Ultra Condensed */}
              <p className="text-white/80 text-sm leading-relaxed font-light">
                {aboutData.subtitle}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
